<template>
  <div style="width:100%;overflow:scroll;float:left;">
    <div style="width:100%;min-width:800px;float:left;">
      <CCard>
        <CCardBody v-if="!loading && !error">
          <div class="row">
            <div class="col-6 float-left">
              <h2 class="bigLabel bold">Customer ({{customer_selected.customer_number}})</h2>
              <div class="row">
                <div class="col-4 float-left tag">Name</div>
                <div class="col-8 float-left data">{{customer_selected.customer_name}}</div>

                <div class="col-4 float-left tag">Phone #</div>
                <div class="col-8 float-left data">{{customer_selected.customer_phone}}</div>

                <div class="col-4 float-left tag">Address</div>
                <div class="col-8 float-left data">
                  {{customer_selected.address_1}}<br />
                  {{customer_selected.city}}, {{customer_selected.state}} {{customer_selected.zip_code}}
                </div>

                <div class="col-4 float-left tag">Term</div>
                <div class="col-8 float-left data">{{customer_selected.term}}</div>
              </div>
            </div>
            <div class="col-6 float-left">
              <h2 class="bigLabel bold">Current Contact</h2>
              <div class="row">
                <div class="col-4 float-left tag">Name</div>
                <div class="col-8 float-left data">{{customer_selected.contact_name}}</div>

                <div class="col-4 float-left tag">Phone #</div>
                <div class="col-8 float-left data">{{customer_selected.customer_phone}}</div>

                <div class="col-4 float-left tag">Email</div>
                <div class="col-8 float-left data">
                  {{customer_selected.customer_email}}
                </div>
              </div>
            </div>
          </div>
          <spacer />
          <div class="row">
            <div class="col-6 float-left">
              <!-- <div class="row">
                <CSwitch
                  class="mx-1"
                  color="success"
                  name="switch1"
                  size="sm"
                  :checked.sync="checker"
                  disabled
                />
                receiving automated invoice
              </div> -->
              <!-- <div class="row mt-2">
                <CSwitch
                  class="mx-1"
                  color="success"
                  name="switch1"
                  size="sm"
                  :checked.sync="checker"
                  disabled
                />
                receiving automated packing list
              </div> -->
              <div class="row mt-2">
                
                <div class="col-4 float-left tag">Rep</div>
                <div class="col-8 float-left data">{{ repName }}</div>

                <div class="col-4 float-left tag">Price Level</div>
                <div class="col-8 float-left data">{{customer_selected.pricing_level_code}} {{customer_selected.pricing_level}}</div>

                <div class="col-4 float-left tag">PGA GRP Member</div>
                <div class="col-8 float-left data">{{ customer_summary.custentity_grp_membername || '--' }}</div>

                <div class="col-4 float-left tag">Management Group</div>
                <div class="col-8 float-left data">{{ customer_summary.custentity_imp_cust_mgmt_group || '--' }}</div>

                <!-- <div class="col-4 float-left tag">Last Order Shipped</div>
                <div class="col-8 float-left data">Coming Soon..</div> -->
              </div>
            </div>
          </div>
          <spacer />
          <div class="row">
            <div class="col-6 float-left">
              

              <h2 class="bigLabel bold">Top Product Class Summary</h2>
              <div class="row">
                <!-- <div class="col-6 float-left tag">MTD Sales Current Month</div> -->
                <div class="col-12 float-left data number">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Class</th>
                        <th>Units (Prev Year)</th>
                        <th>$ (Prev Year)</th>
                        <th>Units (YTD)</th>
                        <th>$ (YTD)</th>
                      </tr>
                    </thead>

                    <tbody v-if="productClassRows.length">
                      <tr v-for="row in productClassRows" :key="row.label">
                        <td>{{ row.label }}</td>
                        <td>{{ row.prevUnits.toLocaleString('en-US') }}</td>
                        <td>${{ formatNumber(row.prevAmount) }}</td>
                        <td>{{ row.ytdUnits.toLocaleString('en-US') }}</td>
                        <td>${{ formatNumber(row.ytdAmount) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <h2 class="bigLabel bold">YTD Summary</h2>
              <div class="row">
                <div class="col-6 float-left tag">YTD Bookings $</div>
                <div class="col-6 float-left data number" v-if="current_ytd">$ {{ formatNumber(current_ytd.creditforeignamount || 0) }}</div>

                <div class="col-6 float-left tag">Last Year Sales (Total) $</div>
                <div class="col-6 float-left data number">$ {{ formatNumber(last_year_total.last_year_total || 0) }}</div>

                <div class="col-6 float-left tag">YTD vs Last Year Sales (Total) - Diff $</div>
                <div class="col-6 float-left data number">$ {{ formatNumber(
                    (Number(current_ytd.creditforeignamount) || 0) -
                    (Number(last_year_total.last_year_total)  || 0)
                ) }}</div>

              </div>

              <h2 class="bigLabel bold mt-3">Receivables</h2>
              <div class="row" v-if="receivables">
                <!-- <div class="col-6 float-left tag">Future</div>
                <div class="col-6 float-left data number">${{ formatNumber(receivables.future) }}</div> -->

                <div class="col-6 float-left tag">Current</div>
                <div class="col-6 float-left data number">${{ formatNumber((receivables && receivables.current) || 0) }}</div>

                <div class="col-6 float-left tag">31-60 days</div>
                <div class="col-6 float-left data number">${{ formatNumber((receivables && receivables.balance60) || 0) }}</div>

                <div class="col-6 float-left tag">61-90 days</div>
                <div class="col-6 float-left data number">${{ formatNumber((receivables && receivables.balance90) || 0) }}</div>

                <div class="col-6 float-left tag">90+ days</div>
                <div class="col-6 float-left data number">${{ formatNumber((receivables && receivables.balance90plus) || 0) }}</div>
                <spacer />
                <div class="col-6 float-left tag">Total</div>
                <div class="col-6 float-left data number">${{ formatNumber((receivables && receivables.total) || 0) }}</div>
              </div>
            </div>

            <div class="col-6 float-left">

              <div class="row">
                <div class="col-6 float-left">
                  <h2 class="bigLabel bold">Invoiced Amount</h2>
                </div>
                <div class="col-6 float-left">
                  <h2 class="bigLabel bold">Open Amount</h2>
                </div>
              </div>

              <div class="row">

                <div class="col-2 float-left tag bold">Month</div>
                <div class="col-2 float-left tag text-right bold">$</div>
                <div class="col-2 float-left tag text-right bold">Units</div>

                <div class="col-2 float-left tag bold">Month</div>
                <div class="col-2 float-left tag text-right bold">$</div>
                <div class="col-2 float-left tag text-right bold">Units</div>

                <div class="all" v-for="(row, i) in pairedOpenOrders" :key="i">
                  <!-- created_at: last month back 12 -->
                  <div class="col-2 float-left tag">{{ row.past ? row.past.date : '\u00A0' }}</div>
                  <div class="col-2 float-left text-right data">{{ row.past ? '$' + formatNumber(row.past.total_price) : '\u00A0' }}</div>
                  <div class="col-2 float-left text-right data">{{ row.past ? row.past.units : '\u00A0' }}</div>

                  <!-- shipdate: this month forward 12 -->
                  <div class="col-2 float-left tag">{{ row.future ? row.future.date : '\u00A0' }}</div>
                  <div class="col-2 float-left text-right data">{{ row.future ? '$' + formatNumber(row.future.total_price) : '\u00A0' }}</div>
                  <div class="col-2 float-left text-right data">{{ row.future ? row.future.units : '\u00A0' }}</div>
                </div>

                <spacer />

                <div class="all">
                  <div class="col-2 float-left tag">Total</div>
                  <div class="col-2 float-left text-right data">${{ formatNumber(configureTotalOpen(openOrders, 'total_price')) }}</div>
                  <div class="col-2 float-left text-right data">{{ Number(configureTotalOpen(openOrders, 'units')).toLocaleString('en-US') }}</div>

                  <div class="col-2 float-left tag">Total</div>
                  <div class="col-2 float-left text-right data">${{ formatNumber(configureTotalOpen(openAmounts, 'total_price')) }}</div>
                  <div class="col-2 float-left text-right data">{{ Number(configureTotalOpen(openAmounts, 'units')).toLocaleString('en-US') }}</div>
                </div>
                
              </div>

            </div>

          </div>
        </CCardBody>
        <CCardBody v-else-if="error" class="text-center">
          <p class="mb-3">This customer's summary didn't load. {{ error }}</p>
          <CButton size="sm" color="info" @click="getCustomerSummary()">Try again</CButton>
        </CCardBody>
        <small-loader v-else></small-loader>
      </CCard>

      <h2 class="bigLabel bold mt-3 mb-4 ml-4">Top Sellers</h2>
      <CRow>
        <customer-top-items @loaded="loadingChanged" :customer_selected="customer_selected"></customer-top-items>
      </CRow>
    </div>
  </div>
</template>
<script>

import CustomerTopItems from './customer_top_items'

var methods = {}

// Pulls items[0] off a response section without throwing when the section is
// missing, isn't shaped the way we expect, or came back with zero rows.
// Several customers legitimately have no row in one section or another.
methods.firstItem = function (section) {
  if (!section) {
    return null
  }
  var items = Array.isArray(section) ? section : section.items
  if (!Array.isArray(items) || items.length === 0) {
    return null
  }
  return items[0] || null
}

methods.getCustomerSummary = function () {
  this.loading = true
  this.error = ''
  const postData = {
    customer: this.customer_selected
  }
  axios.post(this.$apiAdress + '/api/reports/getCustomerSummary?token=' + localStorage.getItem('api_token'), postData).then(response => {
    const data = (response && response.data) || {}

    this.customer_summary = this.firstItem(data.customer_summary) || {}
    this.current_ytd = this.firstItem(data.ytd_current) || {}
    // this.last_ytd = this.firstItem(data.ytd_last_year) || {}
    this.last_year_total = this.firstItem(data.last_year_total) || {}
    this.receivables = this.firstItem(data.receivables) || {}

    if (data.customer) {
      this.customer_info = data.customer
    }
    if (data.product_classes) {
      this.product_classes = data.product_classes
      // Temporary diagnostic: shows exactly which keys the backend sends for
      // a product class row. Remove once the amount field name is confirmed.
      var sampleRow = (Array.isArray(data.product_classes.prev_year) && data.product_classes.prev_year[0]) ||
        (Array.isArray(data.product_classes.ytd) && data.product_classes.ytd[0])
      if (sampleRow) {
        console.log('product class row keys:', Object.keys(sampleRow))
        console.log('product class sample row:', sampleRow)
      }
    }
    // if (data.mtd_summary) {
    //   this.mtd_summary = data.mtd_summary
    // }

    // left group: created_at, last month back 12
    this.openOrders = this.configureOpenOrders(data.open_orders_month)
    // right group: shipdate, this month forward 12
    this.openAmounts = this.configureOpenOrders(data.future_open_orders)
  }).catch(err => {
    // Anything thrown above lands here too, so a bad payload shows a message
    // instead of leaving the spinner up forever.
    console.error('getCustomerSummary failed', err)
    this.error = (err && err.message) ? err.message : 'Please try again.'
  }).finally(() => {
    this.loading = false
    this.$emit('loaded')
  })
}

methods.configureTotalOpen = function (list, type) {
  var total = 0
  if (!Array.isArray(list)) {
    return total
  }
  list.forEach(function (val) {
    total += parseFloat(val[type]) || 0
  })
  return total
}

methods.configureOpenOrders = function (value) {
  var returnArr = []
  if (!value || !Array.isArray(value.monthsyears)) {
    return returnArr
  }
  var items = (value.res && Array.isArray(value.res.items)) ? value.res.items : []
  value.monthsyears.forEach(function (val) {
    var obj = {
      date: val,
      total_price: 0,
      units: 0
    }
    items.forEach(function (item) {
      if (!item || typeof item.month !== 'string') {
        return
      }
      if (item.month.trim() === val) {
        obj.total_price += parseFloat(item.totalamount) || 0
        obj.units += parseFloat(item.totalquantity) || 0
      }
    })
    returnArr.push(obj)
  })
  return returnArr
}

// Amounts come back from the backend as strings, and not always clean ones:
// "1,234.56", "$1,234.56" and "(1,234.56)" for negatives all show up.
// parseFloat returns NaN on all but the first, which is why the $ columns
// were rendering as 0.00 while units rendered fine.
methods.toNumber = function (val) {
  if (typeof val === 'number') {
    return isNaN(val) ? 0 : val
  }
  if (typeof val !== 'string') {
    return 0
  }
  var str = val.trim()
  if (!str) {
    return 0
  }
  var negative = str.charAt(0) === '-' || /^\(.*\)$/.test(str)
  str = str.replace(/[^0-9.]/g, '')
  var num = parseFloat(str)
  if (isNaN(num)) {
    return 0
  }
  return negative ? -num : num
}

// The product class rows don't use the same amount key as the rest of the
// payload, so check the names this API is known to use before giving up.
methods.pickAmount = function (row) {
  var keys = ['amount', 'totalamount', 'total_price', 'foreignamount', 'creditforeignamount', 'total', 'sales', 'amt']
  for (var i = 0; i < keys.length; i++) {
    var val = row[keys[i]]
    if (val !== undefined && val !== null && val !== '') {
      return this.toNumber(val)
    }
  }
  return 0
}

// Handler for <customer-top-items @loaded>. This was referenced in the
// template but never defined here, which is what produced the
// "Invalid handler for event 'loaded': got undefined" warning.
methods.loadingChanged = function (e) {
  this.topItemsLoading = false
}

methods.formatNumber = function (num) {
  var newNum = ''
  num = parseFloat(num)
  if (isNaN(num)) {
    num = 0
  }
  newNum = num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return newNum
}

export default {
  // ===Component name
  name: "CustomerSummary",
  // ===Props passed to component
  props: ['customer_selected', 'customerOptions'],
  // ===Components used by this component
  components: {
    CustomerTopItems, 
  },
  // ====component Data properties
  data(){
      return{
        loading: true,
        error: '',
        topItemsLoading: true,
        current_ytd: {},
        // last_ytd: {},
        last_year_total: {},
        receivables: {},
        customer_summary: {},
        checker: false,
        product_classes: '',
        // mtd_summary: '',
        open_orders_month: '',
        // right column: shipdate, this month forward 12
        openAmounts: [],
        // left column: created_at, last month back 12 (ends last month)
        openOrders: []
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    console.log('customer slected')
    console.log(this.customer_selected)
    this.getCustomerSummary()
  },
  // ===Computed properties for the component
  computed: {
    // The rep lives on the customer record itself. Reading it off
    // customerOptions[0] both threw when a customer had no reps and showed the
    // wrong rep whenever the search returned more than one customer.
    repName: function () {
      var cust = this.customer_selected
      var reps = (cust && Array.isArray(cust.reps)) ? cust.reps : []
      if (!reps.length) {
        var opts = Array.isArray(this.customerOptions) ? this.customerOptions : []
        for (var i = 0; i < opts.length; i++) {
          if (opts[i] && cust && opts[i].customer_number === cust.customer_number) {
            reps = Array.isArray(opts[i].reps) ? opts[i].reps : []
            break
          }
        }
      }
      var names = []
      reps.forEach(function (rep) {
        var name = rep && (rep.name || rep.rep_name)
        if (name) {
          names.push(name)
        }
      })
      return names.length ? names.join(', ') : '--'
    },
    // Matches prev_year and ytd on label instead of array index. The old
    // template assumed both arrays held the same classes in the same order,
    // so any customer with a class in one period but not the other either
    // threw or silently showed another class's numbers.
    productClassRows: function () {
      var self = this
      var pc = this.product_classes
      if (!pc) {
        return []
      }
      var prev = Array.isArray(pc.prev_year) ? pc.prev_year : []
      var ytd = Array.isArray(pc.ytd) ? pc.ytd : []
      var byLabel = {}
      var order = []

      function slot(label) {
        if (!byLabel[label]) {
          byLabel[label] = {
            label: label,
            prevUnits: 0,
            prevAmount: 0,
            ytdUnits: 0,
            ytdAmount: 0
          }
          order.push(label)
        }
        return byLabel[label]
      }

      prev.forEach(function (v) {
        if (!v) { return }
        var row = slot(v.label || '--')
        row.prevUnits = Math.abs(self.toNumber(v.units))
        row.prevAmount = self.pickAmount(v)
      })
      ytd.forEach(function (v) {
        if (!v) { return }
        var row = slot(v.label || '--')
        row.ytdUnits = Math.abs(self.toNumber(v.units))
        row.ytdAmount = self.pickAmount(v)
      })

      return order.map(function (label) {
        return byLabel[label]
      })
    },
    // zips the two month groups into rows so the 6 columns stay aligned
    // even when the groups differ in length
    pairedOpenOrders: function () {
      var past = this.openOrders || []
      var future = this.openAmounts || []
      var len = Math.max(past.length, future.length)
      var rows = []
      for (var i = 0; i < len; i++) {
        rows.push({
          past: past[i] || null,
          future: future[i] || null
        })
      }
      return rows
    },
    // configureYearTrend: function () {
    //   var currentYtd = 0
    //   if (this.current_ytd) {
    //     currentYtd = parseFloat(this.current_ytd.creditforeignamount || 0)
    //   } 
    //   var lastYtd = 0
    //   if (this.last_ytd) {
    //     lastYtd = parseFloat(this.last_ytd.creditforeignamount || 0)
    //   } 
    //   return currentYtd - lastYtd
    // }
  },
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .bigLabel {
    font-size:18px;
  }
  .bold {
    font-weight: 800;
  }
  .data {
    font-weight: 800;
  }
  .tag {
    padding-left: 20px;
  }
  .tag, .data {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .number {
    text-align: right;
  }
</style>